<template>
  <div>
    <div class="has-margin-bottom-40 has-margin-top-10 has-border-bottom">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >
        DG Packaging Details
      </h2>
    </div>
    <div class="columns is-multiline">
      <!-- Gross Mass -->
      <div class="column is-4" v-if="data.gross_mass">
        <b-field label="Container Operator">
          <b-input v-model="data.gross_mass" readonly></b-input>
        </b-field>
      </div>

      <!-- Danegerous Goods Packaging ID -->
      <div class="column is-4" v-if="data.id">
        <b-field label="Danegerous Goods Packaging ID">
          <b-input v-model="data.id" readonly></b-input>
        </b-field>
      </div>

      <!-- Inner Packaging -->
      <div class="column is-4" v-if="data.inner_packaging">
        <b-field label="Inner Packaging">
          <b-input v-model="data.inner_packaging" readonly></b-input>
        </b-field>
      </div>

      <!-- Tare Mass -->
      <div class="column is-4" v-if="data.tare_mass">
        <b-field label="Inner Packaging">
          <b-input v-model="data.tare_mass" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-4" v-if="data.net_mass">
        <b-field label="Net Mass">
          <b-input v-model="data.net_mass" readonly></b-input>
        </b-field>
      </div>

      <!-- Outer Packaging -->
      <div class="column is-4" v-if="data.outer_packaging">
        <b-field label="Outer Packaging">
          <b-input v-model="data.outer_packaging" readonly></b-input>
        </b-field>
      </div>

      <!--Volume -->
      <div class="column is-4" v-if="data.volume">
        <b-field label="Volume">
          <b-input v-model="data.volume" readonly></b-input>
        </b-field>
      </div>

      <!--Container Identification Number-->
      <div class="column is-4" v-if="data.container_id">
        <b-field label="Container Identification Number">
          <b-input v-model="data.container_id" readonly></b-input>
        </b-field>
      </div>

      <!--Seal Number-->
      <div class="column is-4" v-if="data.seal_number">
        <b-field label="Seal Number">
          <b-input v-model="data.seal_number" readonly></b-input>
        </b-field>
      </div>

      <!--Container Type-->
      <div class="column is-4" v-if="data.container_type">
        <b-field label="Container Typ">
          <b-input v-model="data.container_type" readonly></b-input>
        </b-field>
      </div>

      <!--Container Operator-->
      <div class="column is-4" v-if="data.container_operator">
        <b-field label="Container Operator">
          <b-input v-model="data.container_operator" readonly></b-input>
        </b-field>
      </div>

      <!--Container Size-->
      <div class="column is-4" v-if="data.container_size">
        <b-field label="Container Size">
          <b-input v-model="data.container_size" readonly></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DangerousGoodsPackaging",
  components: {},
  props: {
    data: Object
  }
};
</script>
